import type { MapFiltersValue } from './MapFiltersSheet';

/** How many of the sheet's filters are applied; the bar's badge shows it. */
export const countAppliedFilters = (value: MapFiltersValue): number => {
  let count = 0;
  if (!Object.values(value.homeTypes).every(Boolean)) count += 1;
  count += Object.values(value.features).filter(Boolean).length;
  if (value.size.min != null || value.size.max != null) count += 1;
  if (value.lot.min != null || value.lot.max != null) count += 1;
  count += Object.values(value.status).filter(Boolean).length;
  return count;
};
